// Preserve the original Firebase error and its code while carrying a bounded,
// explicitly selected diagnostic payload to the subscription's existing log.
const diagnostics = new WeakMap<object, Record<string, unknown>>();

export function recordStorageDownloadDenial(error: unknown, metadata: Record<string, unknown>): void {
  if (!error || typeof error !== 'object') return;
  const code = (error as { code?: unknown }).code;
  if (code !== 'storage/unauthorized' && code !== 'storage/unauthenticated') return;
  diagnostics.set(error, { storageErrorCode: code, ...metadata });
}

export function getStorageDownloadDiagnostics(error: unknown): Record<string, unknown> | undefined {
  return error && typeof error === 'object' ? diagnostics.get(error) : undefined;
}
